import { showToast } from '@creditas-ui/toast';
export var MessageErrorTypes;

(function (MessageErrorTypes) {
  MessageErrorTypes["error"] = "ERROR";
  MessageErrorTypes["info"] = "INFO";
  MessageErrorTypes["success"] = "SUCCESS";
})(MessageErrorTypes || (MessageErrorTypes = {}));

var dictSymbols = {
  [MessageErrorTypes.error]: '😕',
  [MessageErrorTypes.info]: '🤔',
  [MessageErrorTypes.success]: '😀'
};
export var callToast = (message, errorType) => showToast(message, {
  emoji: {
    symbol: dictSymbols[errorType],
    label: errorType
  },
  duration: 5000,
  variant: 'dark'
});
export default callToast;
//# sourceMappingURL=callToast.js.map